import { User } from './../user/types';

export interface Auth {
  user: User;
}

export const enum AuthActionTypes {
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  LOGOUT = 'LOGOUT',
  SET_USER = 'SET_USER',
  SET_IMAGE = 'SET_IMAGE'
}

export interface AuthState {
  readonly loading: boolean;
  readonly data?: User;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/auth/types.ts